module.exports = __webpack_public_path__ + "img/37_149.aeb9f88b.png";